import moment from 'moment';
import momentTimezone from 'moment-timezone';

import {
  dateTimeFormat,
  DDMMYYYYFormat,
  DDMMYYYYTimeFormat,
  DDMMYYYYHHMMTimeFormat,
  timezoneDiffTimeFormat,
  timezoneTextFormat,
  YYYYMMDDCompactFormat
} from './GlobalConstant';

export const convertISOToDateFormat = (isoDate) => {
  const date = moment(isoDate);

  // check if date is valid and format is given
  if (date.isValid()) {
    return date.format(DDMMYYYYFormat);
  }

  return null;
};

export const convertDateInputToEpoch = (dateInput, isInUTC) => {
  // check if input is a valid date
  const date = moment(dateInput);
  if (date.isValid()) {
    // if timestamp is in UTC already
    if (isInUTC) {
      // input dateInput into moment's UTC together with the timestamp format given (ISO)
      // then return unix in milliseconds using valueOf()
      return moment(dateInput, [dateTimeFormat]).valueOf();
    }

    // convert dateInput to UTC and return unix milliseconds using valueOf()
    return moment.utc(dateInput).valueOf();
  }

  return null;
};

export const convertLocalTimeToEpoch = (dateInput) => {
  // check if input is a valid date
  const date = moment(dateInput);
  if (date.isValid()) {
    // convert dateInput to UTC and return unix milliseconds using valueOf()
    return moment(dateInput, dateTimeFormat).local(true).valueOf();
  }

  return null;
};

export const convertLocalEpochToUTC = (epochDate) => {
  const date = moment(epochDate);

  // check if date is valid and then return utc epoch date
  if (date.isValid()) {
    return moment(epochDate).utc().valueOf();
  }

  return null;
};

export const convertISOToTimeFormat = (isoTime) => {
  const time = moment(isoTime);

  // check if time is valid and format is given
  if (time.isValid()) {
    return time.format('HH:mm');
  }

  return null;
};

export const getLocalTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export const convertISOToDateTimeFormat = (isoDate) => {
  const date = moment(isoDate);
  // check if date is valid and format is given
  if (date.isValid()) {
    return date.format(DDMMYYYYTimeFormat);
  }
};

export const convertISOToDateTimeWithoutSeconds = (isoDate) => {
  const date = moment(isoDate);
  // check if date is valid and format is given
  if (date.isValid()) {
    return date.format(DDMMYYYYHHMMTimeFormat);
  }
};

export const getTimeDifferenceFromUTC = () =>
  moment().format(timezoneDiffTimeFormat);

export const getCurrentTimezoneText = () => {
  const currentTimezone = momentTimezone.tz.guess();

  return momentTimezone.tz(currentTimezone).format(timezoneTextFormat);
};

export const convertISOToDateTimeWithoutSecondsWithTZ = (isoDate) => {
  return (
    convertISOToDateTimeWithoutSeconds(isoDate) + ' ' + getCurrentTimezoneText()
  );
};

export const convertISOToUTCDateFormat = (isoDate) => {
  const date = moment(isoDate);

  // check if date is valid and format is given
  if (date.isValid()) {
    return date.utc().format(DDMMYYYYFormat);
  }

  return null;
};

export const formatTimeDifference = (notificationDate) => {
  const currentDate = new Date();
  const targetDate = new Date(notificationDate);
  const timeDifference = currentDate - targetDate;

  // Defined time intervals below
  const secondsInMs = 1000;
  const minutesInMs = secondsInMs * 60;
  const hoursInMs = minutesInMs * 60;
  const daysInMs = hoursInMs * 24;
  const monthsInMs = daysInMs * 30; // Approximation for a month

  if (timeDifference < minutesInMs) {
    // Less than a minute
    return `${Math.floor(timeDifference / secondsInMs)} secs ago`;
  } else if (timeDifference < hoursInMs) {
    // Less than an hour
    return `${Math.floor(timeDifference / minutesInMs)} mins ago`;
  } else if (timeDifference < daysInMs) {
    // Less than a day
    return `${Math.floor(timeDifference / hoursInMs)} hrs ago`;
  } else if (timeDifference < monthsInMs) {
    // Less than a month
    return `${Math.floor(timeDifference / daysInMs)} days ago`;
  } else {
    // More than a month
    const formattedDate = `${targetDate.getDate()}/${
      targetDate.getMonth() + 1
    }/${targetDate.getFullYear()}`;
    return formattedDate;
  }
};

export const convertISOToCompactDateFormat = (isoDate) => {
  const date = moment(isoDate);

  // check if date is valid and format is given
  if (date.isValid()) {
    return date.format(YYYYMMDDCompactFormat);
  }

  return null;
};
